import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Account from "../users/show";
import { fetchUser } from "../../../modules/api";
import { updatePageTitle } from "../../../modules/legacyUtils";
export default function UserShowPage() {
    const { id } = useParams();
    const [user, setUser] = useState(null);
    useEffect(() => { updatePageTitle('Account'); }, []);
    useEffect(() => { let cancelled = false; fetchUser(id).then(data => { if (cancelled)
        return; setUser(data); }); return () => { cancelled = true; }; }, [id]);
    if (!user)
        return null;
    return /*#__PURE__*/ React.createElement(Account, { addressesPath: "/my_rift/addresses", basicDetailsPath: `/users/${user.id}/edit`, claimsPath: "#", closeAccountPath: "#", communicationPreferencesPath: "/my_rift/communication_preferences", employersPath: "/my_rift/employments" // finance#edit ignores the :id param server-side (always uses
        // current_user.api_person_finance) - see FinanceEditPage.js/finance
        // sub-item notes - so reusing the user's own id here is safe.
        ,
        financesPath: `/finance/${user.id}/edit`, logOutPath: "/users/sign_out", passwordPath: "#", preferencesPath: "/preferences", vehiclesPath: "/my_rift/vehicles" });
}
